/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckCircleIcon16Solid = forwardRef('CheckCircleIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm4.404-8.829a1 1 0 0 0-1.414-1.414L6.68 9.065l-1.67-1.67a1 1 0 0 0-1.415 1.413l1.671 1.671a2 2 0 0 0 2.829 0l4.308-4.308Z" })));
});
